import { createContext, useContext } from "react";

interface SchedulesContextValue {
  isStandalone: boolean;
}

export const SchedulesContext = createContext<SchedulesContextValue>({
  isStandalone: false,
});

export const useSchedulesCard = () => useContext(SchedulesContext);
